module.exports = __webpack_public_path__ + "static/img/宇树机器人G1.51a6a14b.png";